var compare = require('json-schema-compare');

var forEach = require('lodash/forEach');

var _require = require("../common"),
    allUniqueKeys = _require.allUniqueKeys,
    deleteUndefinedProps = _require.deleteUndefinedProps,
    getValues = _require.getValues,
    keys = _require.keys,
    notUndefined = _require.notUndefined,
    uniqWith = _require.uniqWith,
    withoutArr = _require.withoutArr;

function removeFalseSchemas(target) {
  forEach(target, function (schema, prop) {
    if (schema === false) {
      delete target[prop];
    }
  });
}

function mergeSchemaGroup(group, mergeSchemas) {
  var allKeys = allUniqueKeys(group);
  return allKeys.reduce(function (all, key) {
    var schemas = getValues(group, key);
    var compacted = uniqWith(schemas.filter(notUndefined), compare);
    all[key] = mergeSchemas(compacted, key);
    return all;
  }, {});
}

module.exports = {
  keywords: ['properties', 'patternProperties', 'additionalProperties'],
  resolver: function resolver(values, parents, mergers, options) {
    // first get rid of all non permitted properties
    if (!options.ignoreAdditionalProperties) {
      values.forEach(function (subSchema) {
        var otherSubSchemas = values.filter(function (s) {
          return s !== subSchema;
        });
        var ownKeys = keys(subSchema.properties);
        var ownPatternKeys = keys(subSchema.patternProperties);
        var ownPatterns = ownPatternKeys.map(function (k) {
          return new RegExp(k);
        });
        otherSubSchemas.forEach(function (other) {
          var allOtherKeys = keys(other.properties);
          var keysMatchingPattern = allOtherKeys.filter(function (k) {
            return ownPatterns.some(function (pk) {
              return pk.test(k);
            });
          });
          var additionalKeys = withoutArr(allOtherKeys, ownKeys, keysMatchingPattern);
          additionalKeys.forEach(function (key) {
            other.properties[key] = mergers.properties([other.properties[key], subSchema.additionalProperties], key);
          });
        });
      }); // remove disallowed patternProperties

      values.forEach(function (subSchema) {
        var otherSubSchemas = values.filter(function (s) {
          return s !== subSchema;
        });
        var ownPatternKeys = keys(subSchema.patternProperties);

        if (subSchema.additionalProperties === false) {
          otherSubSchemas.forEach(function (other) {
            var allOtherPatterns = keys(other.patternProperties);
            var additionalPatternKeys = withoutArr(allOtherPatterns, ownPatternKeys);
            additionalPatternKeys.forEach(function (key) {
              return delete other.patternProperties[key];
            });
          });
        }
      });
    }

    var returnObject = {
      additionalProperties: mergers.additionalProperties(values.map(function (s) {
        return s.additionalProperties;
      })),
      patternProperties: mergeSchemaGroup(values.map(function (s) {
        return s.patternProperties;
      }), mergers.patternProperties),
      properties: mergeSchemaGroup(values.map(function (s) {
        return s.properties;
      }), mergers.properties)
    };

    if (returnObject.additionalProperties === false) {
      removeFalseSchemas(returnObject.properties);
    }

    return deleteUndefinedProps(returnObject);
  }
};